<template>
    <div id="app">
      <el-cascader
        size="large"
        :options="pcaTextArr"
        v-model="selectedOptions"
        @change="selectCity"
        placeholder="请选择城市"
        >
      </el-cascader>
    </div>
  </template>
  
  <script setup>
  import { defineEmits, ref } from 'vue'
  import { pcaTextArr } from 'element-china-area-data'
  
  const emit = defineEmits(["dataCity"]);

  const selectedOptions = ref([]);
  
  const selectCity = () => {
    const selectedCity = selectedOptions.value[selectedOptions.value.length - 1];
    // 假设这里的 this.$message 是您自定义的弹窗组件的调用
    emit('dataCity', selectedCity);
  }
</script>

  <style scoped>
</style>